import { render, staticRenderFns } from "./Idps.vue?vue&type=template&id=9c8c040a&"
import script from "./Idps.vue?vue&type=script&lang=js&"
export * from "./Idps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports